import React from "react";
import {Helmet} from "react-helmet";
import {ViviaWisperwind} from "../../constants/meta";

export const A35Meta = () => (
    <Helmet>
        <title>Vivia Wisperwind | Vieunite </title>
        <meta name="twitter:card" value="summary"/>
        <meta name="twitter:site" value="@VieuniteHQ"/>
        <meta name="twitter:title" value="Vieunite Artist | Vivia Wisperwind"/>
        <meta name="twitter:description"
              content=". By deliberately avoiding the use of black, Vivia creates vibrant, luminous compositions filled with movement, warmth, and emotional energy that invite viewers into a more reflective and intuitive state. "/>
        <meta name="twitter:image" value="https://vieunite.com/images/vieunite_sc_vivia_wisperwind.jpg"/>
        <meta property="og:type" content="website"/>
        <meta property="og:title" content="Vieunite Artist | Vivia Wisperwind"/>
        <meta property="og:description"
              content=" By deliberately avoiding the use of black, Vivia creates vibrant, luminous compositions filled with movement, warmth, and emotional energy that invite viewers into a more reflective and intuitive state. "/>
        <meta property="og:image" content="https://vieunite.com/images/vieunite_sc_ vivia_wisperwind.jpg"/>


    </Helmet>);